module.exports = __webpack_public_path__ + "img/arrow-up-active.44d19961.svg";